import brassPaystackCover from "assets/media/images/blog/brass_paystack_cover_v3.png";

const staticBlogCoverBySlug: Record<string, string> = {
  "brass-business-banking-moves-into-paystack-mfb": brassPaystackCover,
};

const getPostSlugKey = (value: string) => value.split("/").filter(Boolean).pop() || value;

export const getStaticBlogCover = (slugOrPath?: string) =>
  slugOrPath ? staticBlogCoverBySlug[getPostSlugKey(slugOrPath)] : undefined;

export default staticBlogCoverBySlug;
